
import { useState, useEffect } from 'react';
import { DebitCard } from '@/types/payment';

export const usePaymentCards = () => {
  const [debitCards, setDebitCards] = useState<DebitCard[]>([]);

  // Generate a unique ID without relying on external packages
  const generateId = () => {
    return 'id_' + Date.now().toString(36) + Math.random().toString(36).substring(2, 9);
  };
  
  // Load initial data from localStorage on component mount
  useEffect(() => {
    const storedDebitCards = localStorage.getItem('debitCards');
    if (storedDebitCards) {
      setDebitCards(JSON.parse(storedDebitCards));
    }
  }, []);

  // Update localStorage whenever debitCards change
  useEffect(() => {
    localStorage.setItem('debitCards', JSON.stringify(debitCards));
  }, []);

  const addDebitCard = (card: Omit<DebitCard, 'id' | 'timestamp'>) => {
    const newDebitCard: DebitCard = {
      id: generateId(),
      timestamp: new Date().toISOString(),
      ...card,
    };
    setDebitCards((prevDebitCards) => [newDebitCard, ...prevDebitCards]);
  };

  return {
    debitCards,
    addDebitCard,
  };
};
